import angular from 'angular';

angular.module('cloudX').filter('resourceName', ['translateListFilter', resourceName]);

function resourceName(translateListFilter) {
  return function(item, withoutCode, withoutCategoryPrefix) {
    if (!item) return '';
    const codePrefix = item.code && !withoutCode ? `${item.code} – ` : '';
    if (item.categoryId && !withoutCategoryPrefix) {
      const categoryName = translateListFilter(
        item.categoryId,
        'resourcecategory',
        item.categoryName,
      );
      if (item.isDefault) return `${codePrefix}${categoryName}`;
      return `${codePrefix}${categoryName}: ${translateListFilter(item.id, 'resource', item.name)}`;
    }
    return `${codePrefix}${translateListFilter(item.id, 'resource', item.name)}`;
  };
}
